const stoneNumber = document.querySelector('#product-grid').dataset.stonenumber;
const customProducts = document.querySelectorAll('.custom-product input');
const selectedCustomProducts = document.querySelectorAll('.custom-product input:checked');
const errorHolder = document.querySelector('.error-info-stone');
const calculationButton = document.querySelector('.calculation-button');
const productInfoContainer = document.querySelector('.full-products-info');

customProducts.forEach(product => {
  product.addEventListener('change', (event) => {
    const selectedProducts = document.querySelectorAll('.custom-product input:checked').length;
    if(selectedProducts == Number(stoneNumber)) {
      errorHolder.textContent = "You've selected your stone(s). Please select additional options at the bottom of the page.";
      calculationButton.classList.add('ready');
      if(calculationButton.classList.contains('feature-product-ready') || calculationButton.classList.contains('no-feature-product-validation')) {
        calculationButton.removeAttribute("disabled");
      } else {
        calculationButton.setAttribute("disabled", true);
      }
    } else if(selectedProducts < Number(stoneNumber)) {
      errorHolder.textContent = 'Please select one more stone.';
      calculationButton.classList.remove('ready')
      calculationButton.setAttribute("disabled", true);
    } else if(selectedProducts == 0) {
      calculationButton.classList.remove('ready');
      errorHolder.textContent = 'Please select item(s)';
      calculationButton.setAttribute("disabled", true);
    } else if(selectedProducts > Number(stoneNumber)){
      errorHolder.textContent = 'You have selected too many gems. Please select only TWO stones.';
      calculationButton.classList.remove('ready');
      calculationButton.setAttribute("disabled", true);
    }
  });



  if(product.type == 'radio') {
    product.addEventListener('change', (event) => {
      const allProducts = document.querySelectorAll('.custom-product');
      allProducts.forEach(item => {
        item.classList.remove('tr-checked')
      })
      const parent = product.closest('.custom-product');
      parent.classList.add('tr-checked');
    });
  } else {
    product.addEventListener('change', (event) => {
      const parent = product.closest('.custom-product');
      if (product.checked) {
        parent.classList.add('tr-checked');
      } else {
        parent.classList.remove('tr-checked');
      }
    });
  }


});

calculationButton.addEventListener('click', (event) => {
  productInfoContainer.classList.remove('visually-hidden')
});


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!customElements.get('collection-product-form')) {
  customElements.define('collection-product-form', class CollectionProductForm extends HTMLElement {
    constructor() {
      super();

      this.calculationButton = this.querySelector('.calculation-button');
      this.calculationButton.addEventListener('click', this.onCalculationHandler.bind(this));

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    calculationPrice() {
      let price = 0;
      const selectedProducts = document.querySelectorAll('.custom-product input:checked');
      selectedProducts.forEach(product => {
        const additionalPrice = Number(product.dataset.price);
        price = price + additionalPrice;
      })
      const featureProductPrice = Number(document.querySelector('.custom-featured-product__price').textContent);
      price = price + featureProductPrice;
      const priceWrap = document.querySelector('.total-price');
      priceWrap.textContent = Shopify.formatMoney(price, '${{amount}}').replace(/\.[0-9]{2}$/, '');
      
    }

    getParametersFeatureProduct() {
      const options = document.querySelectorAll('.custom-featured-product .product-form__input');
      const paramList = document.querySelector('.feature-product-full-params');
      let param = [];

      options.forEach(option => {
        const key = option.querySelector('.form__label').getAttribute('data-value');
        const value = option.querySelector('input:checked').value;
        param.push(`<li>${key}: ${value}</li>`)
      })
      paramList.innerHTML = param.join('');
    }

    getParametersStone() {
      const stones = document.querySelectorAll('.custom-product input:checked');
      const paramList = document.querySelector('.stone-full-info');


      stones.forEach(stone => {
        const wrap = stone.closest('.custom-product');
        const titleText = wrap.querySelector('.product-title').textContent;
        const optionList = wrap.querySelector('.product-option-items').innerHTML;
        const parameters =  wrap.querySelectorAll('.has-metafields')
        let wrapper = document.createElement("div");
        let list = document.createElement("ul");
        let params = [];

        parameters.forEach(parameter => {
          const key = parameter.dataset.key;
          const value = parameter.textContent;
          if(value.length > 0) {
            params.push(`<li>${key}: ${value}</li>`)
          }
        })

        params.push(optionList)
        list.innerHTML = params.join('');
        wrapper.innerHTML = `<h2>${titleText}</h2>`;
        wrapper.append(list)
        paramList.append(wrapper)
      })
    }

    onCalculationHandler() {
      const calculationButton = document.querySelector('.calculation-button');
      calculationButton.classList.add('visually-hidden')

      const calculationLoading = document.querySelector('.calculation-loader');
      calculationLoading.classList.remove('visually-hidden')

      this.calculationPrice();
      this.getParametersFeatureProduct();
      this.getParametersStone();
      calculationLoading.classList.add('visually-hidden')
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      let formDataArr = [];

      const featureProductID = document.querySelector('.product-form .input-name-id').value;

        // SC AZ: add Ring Size to the base product
        let props = {};
        props['Ring Size'] = document.querySelector('input[name="properties[ring_size]"]:checked').value;
      
      const featureProductArr = {
        'id': featureProductID,
        'quantity': 1,
        'properties': props
      }
      formDataArr.push(featureProductArr)


      const customProducts = document.querySelectorAll('.custom-product input:checked');

      customProducts.forEach(product => {
        const productHolder =  product.closest('.custom-product');
        const parameters =  productHolder.querySelectorAll('.has-metafields')
        let properties = {};

        // SC AZ: 
        properties['_parent'] = featureProductID;
        
        parameters.forEach(parameter => {
          const key = parameter.dataset.key;
          const value = parameter.textContent;
          if(value.length > 0) {
            properties[key] = value;
          }
        })

        const productArr = {
          'id': product.dataset.variant,
          'quantity': 1,
          'properties': properties
        }
        formDataArr.push(productArr)
      });

      let formData = {
        'items': formDataArr,
        'sections': '', // this.cart.getSectionsToRender().map((section) => section.id),
        'sections_url': window.location.pathname
      };
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.cart.renderContents(response);

      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      });

    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
